import { useGroup } from '@entities/common/groups/index';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { Close } from '@shared/assets/index';
// import { SDisplayFLexR } from '@shared/styles/styledComponentsCommon';
import type { Group } from '@shared/types/common';
import {
  SCard,
  SCostNumber,
  SDeleteButtonAfter,
  SDeleteButtonBefore,
  SGroupCost,
  SGroupName,
  SInputsWrapper,
} from '@shared/ui/costsForGroups/ui/CostAndGroupNameWithButton/styles';
import { IconButton } from '@shared/ui/index';
import { PaymentMethod } from '@shared/ui/inputs/payment-method';
import { SelectPaymentMethod } from '@shared/ui/inputs/select/SelectPaymentMethod/ui.tsx';
import { type SelectPT } from '@shared/ui/inputs/select/ui.tsx';
import type { TextInputMPT } from '@shared/ui/inputs/TextInputM/ui';

export type CostAndGroupNameWithButtonPT = Omit<TextInputMPT, 'register' | 'disabled'> & {
  onBtnClick?: () => void;
  costRegister?: UseFormRegisterReturn<string>;
  group?: Group;
  groupId: number;
  cost?: number;
  shouldBeDisabled?: boolean;
  index: number;
  nameOfFieldArray?: string;
  withPaymentMethod?: SelectPT;
};
export const CostAndGroupNameWithButton = ({
  group,
  cost,
  nameOfFieldArray,
  onBtnClick,
  costRegister,
  shouldBeDisabled,
  groupId,
  index,
  withPaymentMethod,
  ...props
}: CostAndGroupNameWithButtonPT) => {
  const { group: groupDataFromRTK } = useGroup(groupId);
  const groupData = group ?? groupDataFromRTK;
  const { pathname } = useLocation();
  const isEventPage = pathname.includes('events');

  const deleteButton = !shouldBeDisabled && (
    <IconButton variant="transparent" onClick={onBtnClick}>
      <Close />
    </IconButton>
  );

  return (
    <SCard>
      <SInputsWrapper>
        <SCostNumber>
          <SGroupCost
            register={costRegister}
            value={cost}
            disabled={shouldBeDisabled}
            suffix={'RUB'}
            min={0}
            {...props}
          />
          <SDeleteButtonBefore>{deleteButton}</SDeleteButtonBefore>
        </SCostNumber>

        {withPaymentMethod && nameOfFieldArray && <SelectPaymentMethod {...withPaymentMethod} />}

        {isEventPage && nameOfFieldArray && (
          <PaymentMethod fieldName={`${nameOfFieldArray}.${index}.payment_method`} />
        )}

        <SGroupName label="Группа" readOnly value={groupData?.name} disabled={shouldBeDisabled} />
      </SInputsWrapper>

      <SDeleteButtonAfter>{deleteButton}</SDeleteButtonAfter>
    </SCard>
  );
};
